import * as React from "react";
import PropTypes from "prop-types";
import TableCell from "@mui/material/TableCell";
import Tooltip from "@mui/material/Tooltip";

const imgStyle = {
  border: "0.2rem",
  height: "3.5rem",
  width: "5rem",
  borderRadius: "0.5rem",
  objectFit: "cover",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  padding: "0.2rem",
  transition: "transform 0.2s, border-color 0.2s",
};


export default function ImagePreviewCell({ imageUrl, alt }) {
  return (
    <TableCell>
      {imageUrl ? (
        <Tooltip title="Click to preview">
          <a href={imageUrl} target="_blank" rel="noreferrer">
            <img
              src={imageUrl}
              alt={alt}
              style={imgStyle}
              onMouseEnter={(e) => {
                e.target.style.borderColor = "dodgerblue";
                e.target.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = "lightgrey";
                e.target.style.transform = "scale(1)";
              }}
            />
          </a>
        </Tooltip>
      ) : (
        "No Image"
      )}
    </TableCell>
  );
}

ImagePreviewCell.propTypes = {
  imageUrl: PropTypes.string,
  alt: PropTypes.string.isRequired,
};
